import { Box, Popover, Select, Text, useMantineTheme } from '@mantine/core';
import { IconTag } from '@tabler/icons-react';
import { TaskBadge } from 'components/TaskBadge';
import { useLoadTaskTypes } from 'modules/Tasks/api/use-load-task-types';
import { useUpdateTask } from 'modules/Tasks/api/use-update-task';
import { useState } from 'react';
import type { Task } from 'shared/hooks/use-load-tasks';

type EditableTypeBadgeProps = {
  task: Task;
};

export const EditableTypeBadge = ({ task }: EditableTypeBadgeProps) => {
  const theme = useMantineTheme();

  const { taskTypes } = useLoadTaskTypes();
  const { updateTask, isUpdateTaskLoading } = useUpdateTask();

  const [isPopoverOpened, setIsPopoverOpened] = useState(false);

  const handleChange = (value: string | null) => {
    if (!value) return;

    updateTask(
      { id: task.id, data: { taskTypeId: value } },
      { onSettled: () => setIsPopoverOpened(false) },
    );
  };

  const currentTypeDescription = taskTypes.data.find(
    type => type.id === Number(task.task_type_id),
  )?.name;

  return (
    <Popover
      opened={isPopoverOpened}
      onChange={setIsPopoverOpened}
      position="bottom-start"
      withinPortal
    >
      <Popover.Target>
        <Box onClick={e => e.stopPropagation()}>
          <TaskBadge
            icon={<IconTag size={18} stroke={1.5} color={theme.colors.purple[5]} />}
            onClick={() => setIsPopoverOpened(o => !o)}
          >
            <Text size="sm">{currentTypeDescription}</Text>
          </TaskBadge>
        </Box>
      </Popover.Target>
      <Popover.Dropdown p="xs" onClick={e => e.stopPropagation()}>
        <Select
          data={taskTypes.data.map(type => ({ label: type.name, value: type.id.toString() }))}
          value={String(task.task_type_id)}
          onChange={handleChange}
          disabled={isUpdateTaskLoading}
          size="sm"
          w={180}
        />
      </Popover.Dropdown>
    </Popover>
  );
};
